<template>
  <v-navigation-drawer v-model="drawerLocal" app clipped>
    <v-card>
      <v-card-title>{{
        this.$store.state.ProjectStore.selectedProject.name
      }}</v-card-title>
      <v-card-subtitle>Project Description</v-card-subtitle>
    </v-card>
    <v-card @click="mainMenuOnClick('/projects')">
      <v-card-text dense
        ><v-icon small>mdi-arrow-left</v-icon> Back to projects</v-card-text
      >
    </v-card>
    <v-list dense>
      <!-- <v-list-item>
        <v-list-item-content>
          <v-list-item-title>JUMP TO</v-list-item-title>
        </v-list-item-content>
      </v-list-item> -->
      <!-- <v-list-item @click="mainMenuOnClick('/')">
        <v-list-item-action>
          <v-icon>mdi-home-city</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Masterplan list</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item @click="mainMenuOnClick('/')">
        <v-list-item-action>
          <v-icon>mdi-city-variant</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Building list</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item @click="mainMenuOnClick('/')">
        <v-list-item-action>
          <v-icon>mdi-city</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Apartment list</v-list-item-title>
        </v-list-item-content>
      </v-list-item> -->
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  components: {},

  props: {
    source: String,
    project: {},
    drawer: Boolean
  },

  data: () => ({
    drawerLocal: null
  }),

  created() {
    this.$vuetify.theme.dark = true
  },

  methods: {
    mainMenuOnClick: function(menuItemId) {
      if (menuItemId === '/pois') {
        this.$store.dispatch('PoiStore/setPoiContext', 'app')
      }
      this.$router.push(menuItemId).catch(err => {})
    }
  },
  computed: {},
  watch: {
    drawer: function(newValue) {
      this.drawerLocal = newValue
    }
  }
}
</script>
